import { useState, useEffect } from "react";
import { setDoc, doc, getDoc, updateDoc } from "firebase/firestore";
import { db, applicantsCol } from "../../firebase";
import { useUser } from "../../UserContext";
import "../../dash.css";
import { nationalities } from "../../model/nationalities";

export const Personal_info_fields = ({ onSuccess }) => {
  const { user, loading: userLoading } = useUser();
  const userID = user?.uid || "";
  const userEmail = user?.email || "";
  const [hasSavedPersonalInfo, setHasSavedPersonalInfo] = useState(false);
  const [isNewApplicant, setIsNewApplicant] = useState(true);
  const [issavingData, setIssavingData] = useState(false);
  const [disableInputFields, setDisableInputFields] = useState(false);
  const [message, setMessage] = useState("");
  const [isErrorOrSuccMsg, setIsErrorOrSuccMsg] = useState(false);
  const [isErrorMsg, setIsErrorMsg] = useState(false);
  const [formData, setformData] = useState({
    fName: "",
    mName: "",
    lName: " ",
    dob: " ",
    email: "",
    phoneNo: "",
    gender: "",
    nationality: "",
    passportNumber: "",
    personalAddress: "",
  });

  // const [nexTab, setNexTab] =u


  const [loading, setIsloading] = useState(false);
  
  // get applicants details if already registered
  useEffect(() => {
    if (!userID) return;
    setIsloading(true);
    const fetchApplicantDetails = async () => {
      const applicantRef = doc(db, applicantsCol, userID);
      const registeredApplicant = await getDoc(applicantRef);
      if (registeredApplicant.exists()) {
        setIsNewApplicant(false);
        const data = registeredApplicant.data();
         if (data.savedPersonalInfo) {
          setHasSavedPersonalInfo(true);
          setDisableInputFields(true);
          setformData((prev) => ({
            ...prev,
            fName: data.fName,
            mName: data.mName,
            lName: data.lName,
            dob: data.dob,
            email: data.email,
            phoneNo: data.phoneNo,
            gender: data.gender,
            nationality: data.nationality || "",
            passportNumber: data.passportNumber || "",
            personalAddress: data.personalAddress || "",
          }));
          setIsloading(false);
        } else {
          setIsloading(false);
          setHasSavedPersonalInfo(false);
          setDisableInputFields(false);
        }
      } else {
        setIsloading(false);
        setIsNewApplicant(true);
        setDisableInputFields(false);
      }
    };
    fetchApplicantDetails();
  }, [userID, userEmail]);

  const handleChange = (e) => {
    setformData((prev) => ({
      ...prev,
      savedPersonalInfo: true,
      applicantID: userID,
      applicantAccountEmail:userEmail,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIssavingData(true);
    try {
      if (isNewApplicant) {
        await setDoc(doc(db, applicantsCol, userID), formData);
        setIssavingData(false);
        setIsErrorOrSuccMsg(true);
        setIsErrorMsg(false);
        setMessage("personal information saved successfully");
        setDisableInputFields(true);
        if (typeof onSuccess === "function") {
          onSuccess();
        }

      } else {
        const applicantRef = doc(db, applicantsCol, userID);
        await updateDoc(applicantRef, formData);
        setIssavingData(false);
        setIsErrorOrSuccMsg(true);
        setIsErrorMsg(false);
        setDisableInputFields(true);
        hasSavedPersonalInfo?setMessage("personal information updated successfully"):setMessage("personal information saved successfully");
        // if (typeof onSuccess === "function") {
        //   onSuccess();
        // }
      }
    } catch (error) {
      setIssavingData(false);
      setIsErrorOrSuccMsg(true);
      setIsErrorMsg(true);
      setMessage("something went wrong, try again"+ error);
    }
  };

  const enableFields = () => {
    setDisableInputFields(false);
    setIsErrorOrSuccMsg(false);
    setHasSavedPersonalInfo(false);
  };

  if (userLoading || loading) return <div className="loader"></div>;

  return (
    <div className="form-container personal-info">
      {/* Show user ID and email for demonstration */}
      {/* <div style={{ marginBottom: 12, color: '#333', fontSize: 14 }}>
        <b>User ID:</b> {userID} <br />
        <b>Email:</b> {userEmail}
      </div> */}
      {isErrorOrSuccMsg ? (
        <div
          className={`alert alert-${isErrorMsg ? "danger" : "success"}`}
          role="alert"
        >
          {message}
        </div>
      ) : (
        <span></span>
      )}
      <h2 className="form-title">PERSONAL INFORMATION</h2>
      {/* <span style={{color}}>{message}</span> */}
      {disableInputFields ? (
        <button className="btn btn-primary" onClick={enableFields}>
          CHANGE
        </button>
      ) : (
        <span></span>
      )}
      <form onSubmit={handleSubmit}>
        <div className="details">
          <div className="form-fields">
            <label>
              first name <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              placeholder="Enter your first  name"
              name="fName"
              value={formData.fName}
              onChange={handleChange}
              required
              maxLength={50}
              disabled={disableInputFields}
            />
          </div>
          <div className="form-fields">
            <label>
              middle name <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              placeholder="Enter your middle  name"
              name="mName"
              value={formData.mName}
              onChange={handleChange}
              required
              maxLength={50}
              disabled={disableInputFields}
            />
          </div>
          <div className="form-fields">
            <label>
              last name <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              placeholder="Enter your last  name"
              name="lName"
              value={formData.lName}
              onChange={handleChange}
              required
              maxLength={50}
              disabled={disableInputFields}
            />
          </div>
          <div className="form-fields">
            <label>
              gender <span style={{ color: "red" }}>*</span>
            </label>
            <select
              name="gender"
              id="gender"
              value={formData.gender}
              onChange={handleChange}
              disabled={disableInputFields}
              required
            >
              <option value="">--choose gender--</option>
              <option value="male">male</option>
              <option value="female">female</option>
            </select>
          </div>
          <div className="form-fields">
            <label>
              date of birth <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="date"
              name="dob"
              value={formData.dob}
              onChange={handleChange}
              disabled={disableInputFields}
              required
            />
          </div>
          <div className="form-fields">
            <label>
              email <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email"
              disabled={disableInputFields}
              required
            />
          </div>
          <div className="form-fields">
            <label>whatsapp phone number <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="phoneNo"
              value={formData.phoneNo}
              onChange={handleChange}
              placeholder="enter whatsapp phone number"
              disabled={disableInputFields}
              required
            />
          </div>
          <div className="form-fields">
            <label>
              nationality <span style={{ color: "red" }}>*</span>
            </label>
            <select
              name="nationality"
              value={formData.nationality}
              onChange={handleChange}
              disabled={disableInputFields}
              required
            >
              <option value="">--Select your nationality--</option>
              {nationalities.map((nationality, index) => (
                <option key={index} value={nationality}>
                  {nationality}
                </option>
              ))}
            </select>
          </div>
          <div className="form-fields">
            <label>
              passport number 
            </label>
            <input
              type="text"
              name="passportNumber"
              value={formData.passportNumber}
              onChange={handleChange}
              placeholder="optional: (only if you have a passport)"
              disabled={disableInputFields}
              maxLength={50}
            />
          </div>
          <div className="form-fields">
            <label>
              address <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              name="personalAddress"
              value={formData.personalAddress}
              onChange={handleChange}
              placeholder="eg: street, city ,country"
              disabled={disableInputFields}
              required
            />
          </div>
        </div>
        {disableInputFields ? (
          <span></span>
        ) : issavingData ? (
          <div className="loader"></div>
        ) : (
          <button
            type="submit"
            style={hasSavedPersonalInfo ? { background: "green" } : {}}
          >
            {hasSavedPersonalInfo ? "update" : "save"}
          </button>
        )}
      </form>
    </div>
  );
};
